// extracted by mini-css-extract-plugin
export default {"main":"Section_main__ow20l","content":"Section_content__zUXpu"};